<template>
    <form @submit.prevent="savePayment()">
        <div>
            <div class="b2b-card billing-info">
                <div class="header">
                    <h2 class="title-l">Billing Information</h2>
                </div>
                <div class="content">
                    <div class="input-folder billing-input">
                        <div class="input-folder--input">
                            <PrimeInputText
                                type="search"
                                id="billing_po_number"
                                placeholder=""
                                v-model="form.billing_po_number"
                                :class="{
                                    'invalid-state-input': form.errors.billing_po_number
                                }"
                            />
                            <label
                                :class="{
                                    'invalid-state': form.errors.billing_po_number
                                }"
                                for="billing_po_number"
                            >
                                <p class="paragraph-default">P.O. Number</p>
                            </label>
                            
                        </div>
                        <div class="input-folder--support">
                            <p
                                class="input-support-text invalid-state"
                                v-if="form.errors.billing_po_number"
                            >
                                {{ form.errors.billing_po_number }}
                            </p>
                        </div>
                    </div>

                    <div class="input-folder billing-input">
                        <div class="input-folder--input">
                            <PrimeInputText
                                id="email"
                                placeholder=""
                                v-model="form.billing_email"
                                :class="{
                                    'invalid-state-input': form.errors.billing_email
                                }"
                            />
                            <label
                                :class="{
                                    'invalid-state': form.errors.billing_email
                                }"
                                for="email"
                            >
                                <p class="paragraph-default billing-email">Billing Email *</p>
                            </label>
                        </div>
                        <div class="input-folder--support">
                                <p
                                 id="billingEmailError"
                                    class="input-support-text invalid-state"
                                    v-if="form.errors.billing_email"
                                >
                                    {{ form.errors.billing_email }}
                                </p>
                            </div>
                    </div>

                    <div class="input-folder billing-input">
                        <div class="input-folder--input">
                            <PrimeInputText
                                id="alternate_email"
                                v-model="form.billing_alternate_email"
                                placeholder=""
                                :class="{
                                    'invalid-state-input': form.errors.billing_alternate_email
                                }"
                            />
                            <label
                                :class="{
                                    'invalid-state': form.errors.billing_alternate_email
                                }"
                                for="alternate_email"
                            >
                                <p class="paragraph-default alternate-email">Alternate Email</p>
                            </label> 
                        </div>
                        <div class="input-folder--support">
                            <p
                                class="input-support-text invalid-state"
                                v-if="form.errors.billing_alternate_email"
                            >
                                {{ form.errors.billing_alternate_email }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- add radio buttons -->
            <div class="notification-bar-wrapper">  
                <div class="drop-ship-banner">
                    <span class="drop-ship-leftside">
                        <p class="title-s banner-title">
                            Order Type
                        </p>
                        <span class="cta-wrapper">
                            <button id="order_type_order" @click.prevent="setOrderType('Order')" :class="{
                                'primary small red-btn': form.order_type == 'Order',
                                'secondary small': form.order_type != 'Order'
                            }" aria-label="Place an order">Order</button>
                            <button id="order_type_quote" @click.prevent="setOrderType('Quote')" :class="{
                                'secondary small': form.order_type != 'Quote',
                                'primary small red-btn': form.order_type == 'Quote'
                            }" aria-label="Request a quote">Quote</button>
                        </span>
                        <div class="flex-column">
                            <p class="quote-orders">Quote orders will be accessible through your account.</p>
                            <p class="input-support-text invalid-state" v-if="form.errors.order_type">
                                {{ form.errors.order_type }}
                            </p>
                        </div>
                    </span>
                </div>
            </div>  

            <div class="b2b-card billing-info">
                <div class="header">
                    <h2 class="title-l">Payment</h2>
                </div>
                <div class="content">  
                    <p class="invalid-state" v-if="form.errors?.billing_payment_method">{{ form.errors?.billing_payment_method }}</p>        
                    <div class="radio-group">
                        <div  v-for="paymentType in paymentTypes" :key="paymentType.code" class="option-container">
                            <div v-if="paymentType.code == 'MV'" class="option">
                                <div class="card_option">
                                    <label :class="{
                                        'card-wrapper': true,
                                    }">
                                        <input v-model="form.billing_payment_method" type="radio" name="payment_method" id="payment_method_1" :value="paymentType.code" :checked="paymentType.code == form.billing_payment_method">
                                        <div class="label-container">
                                            <span class="paragraph-details semibold card-label" for="payment_method_1">{{ paymentType.name }}</span>
                                        </div>
                                        <div v-if="paymentType.code == 'MV'" class="logos-container">
                                            <MasterCardIcon alt="mastercard-logo" />
                                            <VisaIcon alt="visa-logo" />
                                        </div>
                                    </label>
                                    <div class="input-wrapper toggle-on-check">
                                        <div class="input-row">
                                            <div class="input-folder">
                                                <div class="input-folder--input">
                                                    <custom-select v-model="creditCard" :options="formattedCreditCards" label="Select Card" :error="form.errors['billing_credit_card_id'] != null"/>
                                                </div>
                                                <div class="input-folder--support">
                                                    <p
                                                        class="input-support-text invalid-state"
                                                        v-if="form.errors['billing_credit_card_id']"
                                                    >
                                                        {{ form.errors['billing_credit_card_id'] }}
                                                    </p>
                                                </div>
                                            
                                            </div>
                                        </div>
                                        <div class="input-row" id="credit-card">
                                            <div class="input-folder">
                                                <div class="input-folder--input">
                                                    <PrimeInputText
                                                        id="expiry_date"
                                                        placeholder=""
                                                        v-model="expiryDate"
                                                        readonly
                                                        :class="{
                                                            'invalid-state-input': form.errors['creditCard.cc_exp_month'] || form.errors['creditCard.cc_exp_year']
                                                        }"
                                                    />
                                                    <label
                                                        :class="{
                                                            'invalid-state': form.errors['creditCard.cc_exp_month'] || form.errors['creditCard.cc_exp_year']
                                                        }"
                                                        for="expiry_date"
                                                    >
                                                        <p class="paragraph-default">Expiration Date(MM/YY)</p>
                                                    </label>
                                                </div> 
                                                <div class="input-folder--support">
                                                    <p
                                                        class="input-support-text invalid-state"
                                                        v-if="form.errors['creditCard.cc_exp_month'] || form.errors['creditCard.cc_exp_year']"
                                                    >
                                                        {{ form.errors['creditCard.cc_exp_month'] || form.errors['creditCard.cc_exp_year']}}
                                                    </p>
                                                </div>   
                                            </div>

                                            <!-- name on card -->
                                            <div class="input-folder">
                                                <div class="input-folder--input">
                                                    <PrimeInputText
                                                        id="cc_name"
                                                        placeholder=""
                                                        v-model="cardName"
                                                        readonly
                                                        :class="{
                                                            'invalid-state-input': form.errors['creditCard.cc_name']
                                                        }"
                                                    />
                                                    <label
                                                        :class="{
                                                            'invalid-state': form.errors['creditCard.cc_name']
                                                        }"
                                                        for="cc_name"
                                                    >
                                                        <p class="paragraph-default">Name on Card</p>
                                                    </label>
                                                </div>
                                                <div class="input-folder--support">
                                                    <p
                                                        class="input-support-text invalid-state"
                                                        v-if="form.errors['creditCard.cc_name']"
                                                    >
                                                        {{ form.errors['creditCard.cc_name'] }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="form.billing_payment_method == paymentType.code" class="setting-wrapper">
                                        <div class="settings-link">
                                            <a @click.prevent="addCard" href="#" class="new-card" aria-label="Add a new card">
                                                <PlusIcon class="settings-icon" alt="Add a new card icon" />New Card
                                            </a>
                                            <Link :href="route('account.creditCards')" class="manage-card" aria-label="Manage saved cards">
                                                <GearIcon class="settings-icon" alt="Manage card icon" />Manage Cards
                                            </Link>
                                        </div>
                                    </div>
                                    
                                    <div class="input-folder">
                                        <div class="input-folder--support">
                                            <p class="input-support-text invalid-state" v-if="form.errors['creditCard.credit_card_id']">
                                                {{ form.errors['creditCard.credit_card_id'] }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <label class="option" v-else>
                                    <input v-model="form.billing_payment_method" type="radio" name="payment_method" :id="paymentType.code" :value="paymentType.code">
                                    <div class="label-container">
                                        <div class="image-container">
                                            <span class="paragraph-details semibold" :for="paymentType.code">{{ paymentType.name  }}</span>
                                        </div>
                                    </div>
                            </label>
                        </div>
                    </div>
                           
                    <div class="textarea-folder billing-comments">
                        <textarea id="text-area" placeholder=" " v-model="form.billing_comments" aria-label="Billing comments (optional)" class="input-folder--input"></textarea>
                        <label class="paragraph-default" for="text-area">Billing Comments (Optional)</label>
                    </div>  
                    <p class="credit-note paragraph-details">
                        Please note that your credit card will be charged when your order begins processing in our internal system, NOT during checkout on the website.
                    </p>
                </div>
            </div> 

            <div class="b2b-card billing-info">
                <div class="header">
                    <h2 class="title-l">Save Billing & Payment Information as Default?</h2>
                </div>
                <div class="content">
                    <form class="save-default-payment">
                        <label class="save-default" for="relevance">
                            <input v-model="form.default_billing" type="checkbox" id="relevance" name="sort" aria-label="Save billing and payment information as default">
                            <p class="save-default-copy">Save Default Billing & Payment Settings to Enable Express Checkout on Future Orders</p>
                        </label>
                    </form>
                </div>
            </div> 
                
            <div v-if="formattedCampaigns.length > 0" class="b2b-card billing-info" id="campaign-code-section">
                <div class="header">
                    <h2 class="title-l">Campaign Code</h2>
                </div>
                <div class="content campaign-content">
                    <div class="field-state input-folder campaign-code-input">
                        <custom-select v-model="selectedCampaign" :options="formattedCampaigns" label="Campaign Code"/>
                        <button v-if="selectedCampaign?.key" @click.prevent="clearCampaignCode" class="primary red-btn" id="remove_campaign_button">
                            Remove
                        </button>  
                    </div>
                    <span :class="{
                        'success-wrapper': isValidCampaignCode,
                    }">
                        <p v-if="selectedCampaign?.key && isValidCampaignCode" class="paragraph-details">Successfully applied to your order!</p>
                    </span>
                </div>
            </div>  
                    
            <span class="cta-wrapper shipping">
                <RothcoCta type="submit" class="primary billing btn" aria-label="Continue to review" :disabled="form.processing">
                    Continue to Review
                </RothcoCta>

                <Link :href="route('checkout.shipping')" aria-label="Go back to Shipping">Back to Shipping</Link>
            </span>  
        </div>
    </form>
</template>
<script setup lang="ts">
    import { ref, computed, watch, nextTick, inject, onMounted } from "vue";
    import { Link, usePage } from "@inertiajs/vue3";
    // import { route } from "ziggy-js";
    import { useForm } from "@/helpers/composables/useForm";
    import { string, boolean, object } from "yup";
    import AddDealerCardModal from "@/components/AddDealerCardModal.vue";
    import { useDialog } from "primevue/usedialog";
    import RothcoCta from "@/components/RothcoCta.vue";
    import MasterCardIcon from "@icons/mastercard.svg";
    import VisaIcon from "@icons/visa.svg";
    import PlusIcon from "@icons/plus.svg";
    import GearIcon from "@icons/gear.svg";
    import { router } from "@inertiajs/vue3";
    import useGoogleManager from "@/helpers/composables/google";
    const dialog = useDialog();
    let route = inject("route");
    let props = defineProps({
        sessionBilling: {
            type: Object,
            required: false,
            default() {
                return {};
            }
        },
        defaultCheckoutOptions: {
            type: Object,
            required: false,
            default() {
                return {
                    billing_email: "",
                    billing_email_2: "",
                    order_type: "",
                    payment_method: "",
                    billing_name: "",
                    cardnumber: "",
                    exp_month: "",
                    cc_exp_year: "",
                    billing_comments: ""
                };
            }
        },
        orderTypes: {
            type: Array,
            required: false,
            default() {
                return ["Order","Quote"];
            }
        },
        paymentTypes: {
            type: Array,
            required: false,
            default() {
                return [
                    { code: "MV", name: "MASTER / VISA CARD" },
                    { code: "COD", name: "C.O.D." },
                    { code: "contact", name: "Contact Us For Payment" }
                ];
            }
        },
        creditCards: {
            type: Array,
            required: false,
            default() {
                return [];
            }
        },
        campaigns: {
            type: Array,
            required: false,
            default() {
                return [];
            }
        },
        countries: {
            type: Array<Object>,
            default: []
        },
        regions: {
            type: Array<Object>,
            default: []
        },
    });


    let formattedCreditCards = computed(()=>{
        return props.creditCards.map(card=>{
            return {
                key: card.credit_card_id,
                value: `${card.cc_alias} - XXXX XXXX XXXX ${card.cc_last_4}`
            }
        })
    });

    let creditCard = computed({
        get(){
            return formattedCreditCards.value.find(card=>card.key == form.creditCard.credit_card_id) ?? {
                key: null,
                value: "No Card Selected"
            };
        },
        set(value){
            form.creditCard = props.creditCards.find(card=>card.credit_card_id == value.key) ?? props.creditCards.find(card => card.is_default == 1) ?? {
                credit_card_id: null,
                cc_name: "",
                card_number: "",
                cc_exp_month: "",
                cc_exp_year: "",
                cc_alias: "",
                cc_last_4: ""
            };
        }
    })

    function getDefault({
        sessionField,
        defaultField
    }: {
        sessionField: string;
        defaultField?: string;
    }) {
        if (defaultField == undefined) {
            defaultField = sessionField;
        }

        if(sessionField == 'billing_payment_method'){
            if([null, undefined, ""].includes(props.sessionBilling[sessionField]) && [null, undefined, ""].includes(props.defaultCheckoutOptions[defaultField])){
                return props.paymentTypes.find(paymentType => paymentType.is_customer_default)?.code ?? props.paymentTypes[0]?.code;
            }
        }
        if (
            sessionField == "creditCard" &&
            getDefault({
                sessionField: "billing_payment_method",
                defaultField: "payment_method"
            }) == "MV"
        ) {
            let sessionCreditCard = Array.isArray(
                props.sessionBilling[sessionField]
            )
                ? null
                : props.sessionBilling[sessionField];
            let defaultCreditCard = Array.isArray(
                props.defaultCheckoutOptions[defaultField]
            )
                ? null
                : props.defaultCheckoutOptions[defaultField];

            let databaseDefaultCard = props.creditCards.find(
                (card) => card.is_default == 1
            );
            return (
                sessionCreditCard ||
                defaultCreditCard ||
                databaseDefaultCard || {
                    cc_name: "",
                    card_number: "",
                    cc_exp_month: "",
                    cc_exp_year: "",
                    credit_card_id: "",
                    cc_alias: "",
                    cc_last_4: ""
                }
            );
        } else if (
            sessionField == "creditCard" &&
            getDefault({
                sessionField: "billing_payment_method",
                defaultField: "payment_method"
            }) != "MV"
        ) {
            return {
                cc_name: "",
                card_number: "",
                cc_exp_month: "",
                cc_exp_year: "",
                credit_card_id: "",
                cc_alias: "",
                cc_last_4: ""
            };
        }

        else if( sessionField == 'order_type') {
            if(props.sessionBilling[sessionField] == null && props.defaultCheckoutOptions[defaultField] == null){
                return props.orderTypes[0];
            }
        }
        return (
            props.sessionBilling[sessionField] ||
            props.defaultCheckoutOptions[defaultField] ||
            ""
        );
    }

    const hasBeenToReviewStep = computed(()=>{
        // if session would have this field set, then user should already have passed the billing step and been to review step
        return props.orderTypes.includes(props?.sessionBilling?.order_type);
    })

    const form = useForm({
        useInertia: true,
        inertiaAlias: "Dealer/Billing",
        schema: object({
            billing_po_number: string().default(
                (!hasBeenToReviewStep.value && usePage()?.props?.current_list?.name) 
                || getDefault({ sessionField: "billing_po_number" })
            ),
            default_billing: boolean().default(false),
            billing_email: string()
                .email("Please enter a valid email")
                .required("Billing email is required")
                .default(getDefault({ sessionField: "billing_email" })),
            billing_alternate_email: string()
                .email("Please enter a valid email")
                .default(
                    getDefault({
                        sessionField: "billing_alternate_email",
                        defaultField: "billing_email_2"
                    })
                ),
            order_type: string()
                .required("Order Type is required")
                .default(getDefault({ sessionField: "order_type" })),
            billing_payment_method: string()
                .required("Payment Method is required")
                .default(
                    getDefault({
                        sessionField: "billing_payment_method",
                        defaultField: "payment_method"
                    })
                ),
            creditCard: object({
                credit_card_id: string().nullable().test("mv terms", "Please select a card", (value,ctx)=>{
                    return ctx?.from?.[1]?.value.billing_payment_method != 'MV' || !!value;
                }),
                cc_name: string().notRequired(),
                cc_exp_month: string()
                    .notRequired()
                    .when("cc_exp_year", {
                        is: (value) => {
                            let currentYear = new Date().getFullYear();
                            return value && parseInt(value) <= currentYear;
                        },
                        then: () =>
                            string().test(
                                "cc_exp_month",
                                "Invalid Expiry Month",
                                (value) => {
                                    let currentMonth =
                                        new Date().getMonth() + 1;
                                    return (
                                        (value &&
                                            parseInt(value) >= currentMonth &&
                                            parseInt(value) <= 12) ||
                                        !value
                                    );
                                }
                            ),
                        otherwise: () => string()
                    }),
                cc_exp_year: string()
                    .notRequired()
                    .test("cc_exp_year", "Invalid Expiry Year", (value) => {
                        let currentYear = new Date().getFullYear();
                        return (
                            (value && parseInt(value) >= currentYear) || !value
                        );
                    }),
                cc_alias: string().notRequired(),
                cc_last_4: string().notRequired(),
                gateway_id: string().when("billing_payment_method", {
                    is: (value) => value == "MV",
                    then: () =>
                        string()
                            .nullable()
                            .test("gateway_id", "Invalid Card", (value) => {
                                if (value) {
                                    let gateway = JSON.parse(value);
                                    return (
                                        gateway &&
                                        gateway.gateway_id &&
                                        gateway.is_validated == 1
                                    );
                                }
                                return false;
                            }),
                    otherwise: () => string().notRequired()
                })
            }).default(getDefault({ sessionField: "creditCard" })),
            billing_comments: string().default(
                getDefault({ sessionField: "billing_comments" })
            ),
            billing_name: string().default(
                getDefault({ sessionField: "billing_name" })
            ),
            billing_campaign_code: string()
                .notRequired()
                .default(getDefault({ sessionField: "billing_campaign_code" }))
        }),
        initialErrors: usePage().props?.errors ?? {},
    });

    const cardName = computed({
        get: () => form.creditCard?.cc_name || "",
        set: (value) => {
            form.creditCard.cc_name = value;
        }
    });

    const cardNumber = computed({
        get: () =>
            form.creditCard?.credit_card_id
                ? `xxxx xxxx xxxx ${form.creditCard.cc_last_4}`
                : form.creditCard?.card_number || "",
        set: (value) => {
            form.creditCard.card_number = value
                .replace(/\D/g, "")
                .replace(/(.{4})/g, "$1 ")
                .trim();
        }
    });

    const expMonth = computed({
        get: () => form.creditCard?.cc_exp_month || "",
        set: (value) => {
            form.creditCard.cc_exp_month = value;
        }
    });

    const expYear = computed({
        get: () => form.creditCard?.cc_exp_year || "",
        set: (value) => {
            form.creditCard.cc_exp_year = value;
        }
    });


    const expiryDate = computed({
        get: () =>
            form.creditCard?.cc_exp_month && form.creditCard?.cc_exp_year
                ? `${form.creditCard.cc_exp_month}/${form.creditCard.cc_exp_year.slice(-2)}`
                : "",
        set: (value) => {
            const [month, year] = value.split("/");
            form.creditCard.cc_exp_month = month;
            form.creditCard.cc_exp_year = year;
        }
    });
    const months = Array.from({ length: 12 }, (_, i) =>
        (i + 1).toString().padStart(2, "0")
    );
    const years = Array.from({ length: 30 }, (_, i) =>
        (new Date().getFullYear() + i).toString()
    );

    const isCardSelected = computed(
        () => form.creditCard?.credit_card_id != null
    );
    const showCardDetails = computed(() => form.billing_payment_method == "MV");
    const savePayment = () => {
        if(form.processing) return;

        // Implement savePayment logic here
        
        if (!form.hasErrors) {
            gtmCustomEvent('add_payment_info', {
                currency: "USD",
                payment_type: form.billing_payment_method
            })
            form.transform((data) => ({
                ...data,
                ...(form.creditCard
                    ? {
                          billing_credit_card_id:
                              form.creditCard?.credit_card_id
                      }
                    : {})
            })).post(route("checkout.save-billing"));
        }else{
            // Scroll to the first input that has an error
            let errorElement = document.querySelector('input.invalid-state-input, select.invalid-state-input');
            if(errorElement){
                errorElement.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                nextTick(() => {
                    try{
                        errorElement?.focus?.();
                    }catch(e){
                        console.error(e);
                    }
                });
            }
        }
    };

    const companyId = computed(() => usePage().props.session.company_id);

    const showAddCardModal = ref(false);

    const addCard = () => {
        dialog.open(AddDealerCardModal, {
            props: {
                showHeader: false
            },
            data: {
                companyId: companyId.value,
                countries: props.countries,
                regions: props.regions
            },
            async onClose(event){
                if(event?.data?.new_credit_card_id){
                    router.reload({
                        only: ["creditCards"],
                        onSuccess: (data) => {
                            //set newly added card into input
                            let newCard = formattedCreditCards?.value?.find((option)=>(option.key == event.data.new_credit_card_id));
                            if(newCard){
                                creditCard.value = newCard;
                            }
                        }
                    });
                }
            }
        });
    };

    const formattedCampaigns = computed(()=>{
        return props.campaigns.map((campaign)=>({
            key: campaign.code,
            value: `${campaign.promo}`
        }))
    })

    const selectedCampaign = computed({
        get(){
            let currentCampaign = formattedCampaigns.value.find(campaign=>{
                return campaign.key == form.billing_campaign_code;
            });
            return {
                key: currentCampaign?.key ?? '',
                value: currentCampaign?.value ?? '',
            }
        },
        set(newVal){
            form.billing_campaign_code = newVal?.key;
        }
    })

    let isValidCampaignCode = computed(() => {
        return formattedCampaigns.value.some((campaign)=>(campaign.key == selectedCampaign?.value?.key));
    });

    watch(isValidCampaignCode, (newVal)=>{
        if(!newVal){
            selectedCampaign.value = null;
        }
    }, {immediate: true})

    const clearCampaignCode = ()=>{
        selectedCampaign.value = null;
    }

    watch(
        () => form.billing_payment_method,
        (value) => {
            if (value != "MV") {
                form.creditCard = {
                    cc_name: "",
                    card_number: "",
                    cc_exp_month: "",
                    cc_exp_year: "",
                    credit_card_id: null,
                    cc_alias: ""
                };
            }
        }
    );

    let { gtmCustomEvent } = useGoogleManager();
    onMounted(()=>{
        gtmCustomEvent('b2b_checkout_payment_screen');

        form.validate({all: true})
    })
    
    function setOrderType(orderType) {
        if(props.orderTypes.includes(orderType)) {
            form.order_type = orderType;
        }else{
            throw new Error("Invalid order type");
        }
    }
    

</script>
